import React from 'react'
import { Modal } from 'is24-corecss'
import { useTranslation } from 'react-i18next'

import { InitState } from '../../../../redux/reducers/root/initialState'
import { useAppSelector } from '../../../../app/hooks'
import { useDisableBodyScroll } from '../../hooks/useDisableBodyScroll'

export interface ModalContainerProps {
  title: string
  children: React.ReactNode
  dataTestid?: string
  onClose: () => void
}

const PreviewModalContainer: React.FC<ModalContainerProps> = ({ title, children, dataTestid, onClose }) => {
  const { t } = useTranslation()
  const { previewModalIsOpen } = useAppSelector((state: InitState) => state.previewFeature)
  useDisableBodyScroll(previewModalIsOpen)

  return (
    <Modal
      //@ts-ignore width works with % but wants only number type
      width={'80%'}
      ariaLabelCloseButton='close'
      visible={previewModalIsOpen}
      title={t(title, 'Close')}
      onClose={onClose}
      {...(dataTestid && { 'data-testid': dataTestid })}
    >
      {children}
    </Modal>
  )
}

export default PreviewModalContainer
